var map = {
	"./SDGs01.svg": 9066,
	"./SDGs02.svg": 7186,
	"./SDGs03.svg": 420,
	"./SDGs04.svg": 2532,
	"./SDGs05.svg": 1590,
	"./SDGs06.svg": 3793,
	"./SDGs07.svg": 8643,
	"./SDGs08.svg": 5910,
	"./SDGs09.svg": 4779,
	"./SDGs10.svg": 9315,
	"./SDGs11.svg": 1561,
	"./SDGs12.svg": 7253,
	"./SDGs13.svg": 6966,
	"./SDGs14.svg": 6981,
	"./SDGs15.svg": 5988,
	"./SDGs16.svg": 658,
	"./SDGs17.svg": 1540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;